import "./repo.713e3393.js";
import "./repo.58ede2b7.js";
import "./repo.91ea9c32.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ed3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ed3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $fGeaS = parcelRequire("fGeaS");

var $dlXig = parcelRequire("dlXig");



var $6l6B5 = parcelRequire("6l6B5");

var $h7C4J = parcelRequire("h7C4J");

var $99eL8 = parcelRequire("99eL8");

var $j3TSU = parcelRequire("j3TSU");

var $gzHIW = parcelRequire("gzHIW");



var $jEyqx = parcelRequire("jEyqx");

var $8Qx3l = parcelRequire("8Qx3l");

var $7lKbG = parcelRequire("7lKbG");

var $gKeLP = parcelRequire("gKeLP");
// ─── Constants ───────────────────────────────────────────────────────────────
const $2a4f034c9d8a0fd5$var$PAGE_SIZE = 75;
const $2a4f034c9d8a0fd5$var$PMG_BASE = "https://pmg.org.za/committee-question/";
const $2a4f034c9d8a0fd5$var$TYPE_LABELS = {
    written: "Written",
    oral: "Oral",
    president: "President",
    deputy_president: "Deputy President"
};
// ─── Helpers ─────────────────────────────────────────────────────────────────
function $2a4f034c9d8a0fd5$var$parseDate(str) {
    if (!str || typeof str !== "string") return null;
    // Handles "Thursday, February 06, 2026" and "2026-02-27"
    const cleaned = str.replace(/^[A-Za-z]+,\s*/, "").trim();
    // If it looks like ISO (YYYY-MM-DD), parse directly — some browsers
    // mis-parse DD-MM-YYYY or treat it as UTC causing off-by-one issues.
    const iso = cleaned.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (iso) {
        const d = new Date(parseInt(iso[1]), parseInt(iso[2]) - 1, parseInt(iso[3]));
        return isNaN(d) ? null : d;
    }
    try {
        const d = new Date(cleaned);
        return isNaN(d) ? null : d;
    } catch  {
        return null;
    }
}
function $2a4f034c9d8a0fd5$var$yearFromDate(str) {
    const d = $2a4f034c9d8a0fd5$var$parseDate(str);
    return d ? d.getFullYear() : null;
}
function $2a4f034c9d8a0fd5$var$statusClass(status) {
    if (!status) return "status-other";
    const s = status.toUpperCase();
    if (s === "TIMEOUS") return "status-timeous";
    if (s === "LATE") return "status-late";
    if (s === "LAPSED" || s === "L") return "status-lapsed";
    if (s.includes("146") || s.startsWith("R")) return "status-r146";
    return "status-other";
}
function $2a4f034c9d8a0fd5$var$daysClass(days) {
    if (days === null) return "days-na";
    if (days <= 14) return "days-fast";
    if (days <= 30) return "days-ok";
    return "days-slow";
}
function $2a4f034c9d8a0fd5$var$sortData(data, key, dir) {
    if (!key) return data;
    return [
        ...data
    ].sort((a, b)=>{
        const av = a[key] ?? "";
        const bv = b[key] ?? "";
        // Date columns
        if (av instanceof Date && bv instanceof Date) return dir === "asc" ? av - bv : bv - av;
        if (typeof av === "number" && typeof bv === "number") return dir === "asc" ? av - bv : bv - av;
        return dir === "asc" ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
    });
}
// ── Generic sortable table for summary sections ───────────────────────────────
function $2a4f034c9d8a0fd5$var$useSimpleSort(initialKey, initialDir = "desc") {
    const [sortKey, setSortKey] = (0, $acw62.useState)(initialKey);
    const [sortDir, setSortDir] = (0, $acw62.useState)(initialDir);
    const onSort = (col)=>{
        if (sortKey === col) setSortDir((d)=>d === "asc" ? "desc" : "asc");
        else {
            setSortKey(col);
            setSortDir("desc");
        }
    };
    return {
        sortKey: sortKey,
        sortDir: sortDir,
        onSort: onSort
    };
}
function $2a4f034c9d8a0fd5$var$SimpleSortTh({ col: col, label: label, sortKey: sortKey, sortDir: sortDir, onSort: onSort, style: style }) {
    const cls = sortKey === col ? sortDir === "asc" ? "sorted-asc" : "sorted-desc" : "";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
        className: cls,
        style: style,
        onClick: ()=>onSort(col),
        children: label
    });
}
// ─── Sub-components ───────────────────────────────────────────────────────────
function $2a4f034c9d8a0fd5$var$StatusPill({ status: status }) {
    const label = status || "\u2014";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `status-pill ${$2a4f034c9d8a0fd5$var$statusClass(status)}`,
        children: label
    });
}
function $2a4f034c9d8a0fd5$var$DaysChip({ days: days }) {
    if (days === null || isNaN(days)) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "days-chip days-na",
        children: "\u2014"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: `days-chip ${$2a4f034c9d8a0fd5$var$daysClass(days)}`,
        children: [
            days,
            "d"
        ]
    });
}
function $2a4f034c9d8a0fd5$var$Badge(props) {
    if (props.party) {
        let pic = props.pic;
        if (props.pic == 'Al Jama-ah') pic = 'ALJ';
        else if (props.pic == 'RISE Mzansi') pic = 'RISE';
        else if (props.pic == 'Action SA') pic = 'ASA';
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "party_member_badge",
            style: {
                backgroundImage: `url(/assets/party-logos/${pic}.png)`
            }
        });
    }
    if (!props.pic) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "party_member_badge",
        style: {
            backgroundImage: `url(https://static.pmg.org.za/${props.pic})`
        }
    });
}
function $2a4f034c9d8a0fd5$var$CardBar({ value: value, avg: avg }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "card-bar",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "card-bar-fill",
                style: {
                    width: `${Math.min(parseFloat(value) || 0, 100)}%`
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "card-bar-mark",
                style: {
                    left: `${Math.min(parseFloat(avg) || 0, 100)}%`
                }
            })
        ]
    });
}
function $2a4f034c9d8a0fd5$var$SortTh({ col: col, label: label, sortKey: sortKey, sortDir: sortDir, onSort: onSort, style: style }) {
    const cls = sortKey === col ? sortDir === "asc" ? "sorted-asc" : "sorted-desc" : "";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
        className: cls,
        style: style,
        onClick: ()=>onSort(col),
        children: label
    });
}
// ─── Main component ────────────────────────────────────────────────────────────
function $2a4f034c9d8a0fd5$var$QuestionsExplorer() {
    // ── Data state ──
    const [questionsData, setQuestionsData] = (0, $acw62.useState)([]);
    const [membersData, setMembersData] = (0, $acw62.useState)([]);
    const [partiesData, setPartiesData] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    // ── Explorer state ──
    const [filterParty, setFilterParty] = (0, $acw62.useState)("All");
    const [filterMinister, setFilterMinister] = (0, $acw62.useState)("All");
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)("All");
    const [filterType, setFilterType] = (0, $acw62.useState)("All");
    const [searchText, setSearchText] = (0, $acw62.useState)("");
    const [page, setPage] = (0, $acw62.useState)(1);
    const [sortKey, setSortKey] = (0, $acw62.useState)("pubDate");
    const [sortDir, setSortDir] = (0, $acw62.useState)("desc");
    const [selectedYear, setSelectedYear] = (0, $acw62.useState)("All");
    // ── Summary-table sort states ──
    const minSort = $2a4f034c9d8a0fd5$var$useSimpleSort("count", "desc");
    const memberSort = $2a4f034c9d8a0fd5$var$useSimpleSort("count", "desc");
    const partySort = $2a4f034c9d8a0fd5$var$useSimpleSort("count", "desc");
    const lateSort = $2a4f034c9d8a0fd5$var$useSimpleSort("late", "desc");
    const fastSort = $2a4f034c9d8a0fd5$var$useSimpleSort("avg", "asc");
    // ─── Load data ──────────────────────────────────────────────────────────────
    (0, $acw62.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($gKeLP))).parse("/data/questions/questions.csv", {
            download: true,
            header: true,
            skipEmptyLines: true,
            delimiter: ",",
            transformHeader: (h)=>h.trim(),
            complete: (res)=>{
                setQuestionsData(res.data);
                setLoading(false);
            },
            error: ()=>setLoading(false)
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gKeLP))).parse("/data/members-parties.csv", {
            download: true,
            header: true,
            skipEmptyLines: true,
            delimiter: ",",
            transformHeader: (h)=>h.trim(),
            complete: (res)=>setMembersData(res.data),
            error: ()=>{}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gKeLP))).parse("/data/parties.csv", {
            download: true,
            header: true,
            skipEmptyLines: true,
            delimiter: ",",
            transformHeader: (h)=>h.trim(),
            complete: (res)=>setPartiesData(res.data),
            error: ()=>{}
        });
    }, []);
    // ─── Enriched dataset ───────────────────────────────────────────────────────
    // ─── Member lookup (id → member info) ──────────────────────────────────────
    const memberLookup = (0, $acw62.useMemo)(()=>{
        const map = {};
        membersData.forEach((m)=>{
            if (m.id) map[m.id] = m;
        });
        return map;
    }, [
        membersData
    ]);
    // ─── Party lookup (id → party name) ────────────────────────────────────────
    const partyLookup = (0, $acw62.useMemo)(()=>{
        const map = {};
        partiesData.forEach((p)=>{
            if (p.id) map[p.id] = p.party;
        });
        return map;
    }, [
        partiesData
    ]);
    const enrichedData = (0, $acw62.useMemo)(()=>{
        if (!questionsData.length) return [];
        return questionsData.map((row)=>{
            const pub = $2a4f034c9d8a0fd5$var$parseDate(row["Date of publication"]);
            const replied = $2a4f034c9d8a0fd5$var$parseDate(row["Date replied to"]);
            const displayStatus = (row["Response"] || "").trim();
            const daysToReply = pub && replied ? Math.round((replied - pub) / 86400000) : null;
            // Guard against nonsensical negative values (bad dates / parsing)
            const safeDays = daysToReply !== null && daysToReply >= 0 ? daysToReply : null;
            const pmgId = (row["pmg_id"] || "").trim();
            const memberId = (row["member_id"] || "").trim();
            const memberInfo = memberLookup[memberId];
            return {
                ...row,
                displayStatus: displayStatus,
                pubDate: pub,
                repliedDate: replied,
                daysToReply: safeDays,
                typeLabel: $2a4f034c9d8a0fd5$var$TYPE_LABELS[(row["type"] || "").trim()] || row["type"] || "",
                pmgUrl: pmgId ? `${$2a4f034c9d8a0fd5$var$PMG_BASE}${pmgId}/` : null,
                profile_pic: memberInfo?.profile_pic || null
            };
        });
    }, [
        questionsData,
        memberLookup
    ]);
    // ─── Years (derived from the loaded data) ──────────────────────────────────
    const years = (0, $acw62.useMemo)(()=>{
        const s = new Set();
        enrichedData.forEach((r)=>{
            const y = $2a4f034c9d8a0fd5$var$yearFromDate(r["Date of publication"]);
            if (y) s.add(y);
        });
        return [
            "All",
            ...Array.from(s).sort((a, b)=>b - a)
        ];
    }, [
        enrichedData
    ]);
    // ─── Year-filtered dataset ──────────────────────────────────────────────────
    // All stats and summary tables below use this, so they reflect the selected
    // year (or "All" for the combined dataset).
    const yearData = (0, $acw62.useMemo)(()=>{
        if (selectedYear === "All") return enrichedData;
        return enrichedData.filter((r)=>r.pubDate && r.pubDate.getFullYear() === selectedYear);
    }, [
        enrichedData,
        selectedYear
    ]);
    // ─── Stats ──────────────────────────────────────────────────────────────────
    const stats = (0, $acw62.useMemo)(()=>{
        if (!yearData.length) return null;
        let timeous = 0, late = 0, lapsed = 0, r146 = 0, other = 0;
        let totalDays = 0, countWithDays = 0;
        const byParty = {};
        const byMinister = {};
        const byMember = {};
        yearData.forEach((row)=>{
            const status = (row.displayStatus || "").toUpperCase().trim();
            if (status === "TIMEOUS") timeous++;
            else if (status === "LATE") late++;
            else if (status === "LAPSED" || status === "L") lapsed++;
            else if (status.includes("146") || status.startsWith("R146")) r146++;
            else other++;
            if (row.daysToReply !== null && !isNaN(row.daysToReply)) {
                totalDays += row.daysToReply;
                countWithDays++;
            }
            const party = (row["PARTY"] || "").trim();
            if (party) byParty[party] = (byParty[party] || 0) + 1;
            const exec = (row["Executive"] || row["department"] || "").trim();
            if (exec) byMinister[exec] = (byMinister[exec] || 0) + 1;
            const memName = (row["Member asking"] || "").trim();
            const memId = (row["member_id"] || "").trim();
            const memKey = memId || memName;
            if (memKey) {
                if (!byMember[memKey]) {
                    const memInfo = memberLookup[memId];
                    byMember[memKey] = {
                        member: memName,
                        count: 0,
                        profile_pic: memInfo?.profile_pic || null,
                        party: memInfo?.party_id ? partyLookup[memInfo.party_id] || null : null
                    };
                }
                byMember[memKey].count++;
            }
        });
        const topParties = Object.entries(byParty).map(([party, count])=>({
                party: party,
                count: count
            })).sort((a, b)=>b.count - a.count);
        const topMinisters = Object.entries(byMinister).map(([minister, count])=>({
                minister: minister,
                count: count
            })).sort((a, b)=>b.count - a.count).slice(0, 30);
        const topMembers = Object.values(byMember).map((m)=>({
                member: m.member,
                count: m.count,
                profile_pic: m.profile_pic,
                party: m.party
            })).sort((a, b)=>b.count - a.count).slice(0, 30);
        return {
            total: yearData.length,
            timeous: timeous,
            late: late,
            lapsed: lapsed,
            r146: r146,
            other: other,
            avgDays: countWithDays > 0 ? Math.round(totalDays / countWithDays) : null,
            topParties: topParties,
            topMinisters: topMinisters,
            topMembers: topMembers
        };
    }, [
        yearData,
        memberLookup,
        partyLookup
    ]);
    // ─── Filter options ─────────────────────────────────────────────────────────
    const parties = (0, $acw62.useMemo)(()=>{
        const s = new Set(yearData.map((r)=>(r["PARTY"] || "").trim()).filter(Boolean));
        return [
            "All",
            ...Array.from(s).sort()
        ];
    }, [
        yearData
    ]);
    const ministers = (0, $acw62.useMemo)(()=>{
        const s = new Set();
        yearData.forEach((r)=>{
            const v = (r["Executive"] || r["department"] || "").trim();
            if (v) s.add(v);
        });
        return [
            "All",
            ...Array.from(s).sort()
        ];
    }, [
        yearData
    ]);
    const statuses = (0, $acw62.useMemo)(()=>{
        const s = new Set(yearData.map((r)=>(r.displayStatus || "").trim()).filter(Boolean));
        return [
            "All",
            ...Array.from(s).sort()
        ];
    }, [
        yearData
    ]);
    const questionTypes = (0, $acw62.useMemo)(()=>{
        const s = new Set(yearData.map((r)=>(r["type"] || "").trim()).filter(Boolean));
        return [
            "All",
            ...Array.from(s).sort()
        ];
    }, [
        yearData
    ]);
    // ─── Filtered + sorted data ─────────────────────────────────────────────────
    const filteredData = (0, $acw62.useMemo)(()=>{
        let data = yearData;
        if (filterType !== "All") data = data.filter((r)=>(r["type"] || "").trim() === filterType);
        if (filterParty !== "All") data = data.filter((r)=>(r["PARTY"] || "").trim() === filterParty);
        if (filterMinister !== "All") data = data.filter((r)=>{
            const exec = (r["Executive"] || r["department"] || "").trim();
            return exec === filterMinister;
        });
        if (filterStatus !== "All") data = data.filter((r)=>(r.displayStatus || "").trim() === filterStatus);
        if (searchText.trim()) {
            const q = searchText.trim().toLowerCase();
            data = data.filter((r)=>(r["ACC No"] || "").toLowerCase().includes(q) || (r["Member asking"] || "").toLowerCase().includes(q) || (r["Executive"] || r["department"] || "").toLowerCase().includes(q) || (r["PARTY"] || "").toLowerCase().includes(q));
        }
        return $2a4f034c9d8a0fd5$var$sortData(data, sortKey, sortDir);
    }, [
        yearData,
        filterType,
        filterParty,
        filterMinister,
        filterStatus,
        searchText,
        sortKey,
        sortDir
    ]);
    const totalPages = Math.max(1, Math.ceil(filteredData.length / $2a4f034c9d8a0fd5$var$PAGE_SIZE));
    const pagedData = filteredData.slice((page - 1) * $2a4f034c9d8a0fd5$var$PAGE_SIZE, page * $2a4f034c9d8a0fd5$var$PAGE_SIZE);
    function handleSort(col) {
        if (sortKey === col) setSortDir((d)=>d === "asc" ? "desc" : "asc");
        else {
            setSortKey(col);
            setSortDir("asc");
        }
        setPage(1);
    }
    function resetFilters() {
        setFilterParty("All");
        setFilterMinister("All");
        setFilterStatus("All");
        setFilterType("All");
        setSearchText("");
        setPage(1);
    }
    // ─── Pagination helper ───────────────────────────────────────────────────────
    function Pagination({ current: current, total: total, onChange: onChange, count: count }) {
        const start = Math.max(1, current - 2);
        const end = Math.min(total, current + 2);
        const pages = [];
        for(let i = start; i <= end; i++)pages.push(i);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "explorer-pagination",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "page-btn",
                    disabled: current === 1,
                    onClick: ()=>onChange(current - 1),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                        icon: (0, $8Qx3l.faChevronLeft)
                    })
                }),
                start > 1 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "page-btn",
                            onClick: ()=>onChange(1),
                            children: "1"
                        }),
                        start > 2 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "\u2026"
                        })
                    ]
                }),
                pages.map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `page-btn ${p === current ? "active" : ""}`,
                        onClick: ()=>onChange(p),
                        children: p
                    }, p)),
                end < total && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        end < total - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: "\u2026"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: "page-btn",
                            onClick: ()=>onChange(total),
                            children: total
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "page-btn",
                    disabled: current === total,
                    onClick: ()=>onChange(current + 1),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                        icon: (0, $8Qx3l.faChevronRight)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                    className: "page-info",
                    children: [
                        (current - 1) * $2a4f034c9d8a0fd5$var$PAGE_SIZE + 1,
                        "\u2013",
                        Math.min(current * $2a4f034c9d8a0fd5$var$PAGE_SIZE, count),
                        " of ",
                        count.toLocaleString()
                    ]
                })
            ]
        });
    }
    // ─── Render ──────────────────────────────────────────────────────────────────
    if (loading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fGeaS.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dlXig.default), {
                active: "questions"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loading-state",
                children: "Loading questions data\u2026"
            })
        ]
    });
    const maxMinstCount = (stats?.topMinisters || []).slice(0, 1)[0]?.count || 1;
    const maxMemberCount = (stats?.topMembers || []).slice(0, 1)[0]?.count || 1;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fGeaS.default), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dlXig.default), {
                active: "questions"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6l6B5.default), {
                fluid: true,
                className: "pt-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "overview-container",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                        className: "align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    children: "Questions Explorer"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                xs: "auto",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "badge text-bg-dark py-1 px-2",
                                    children: [
                                        stats?.total.toLocaleString() || "\u2026",
                                        " questions"
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6l6B5.default), {
                fluid: true,
                className: "pb-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "overview-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "qs-nav",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: "#status",
                                            children: "Response status"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: "#register",
                                            children: "Questions explorer"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: "#ministers",
                                            children: "By minister"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: "#members",
                                            children: "By member"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "form-label",
                                            children: "Year:"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gzHIW.default), {
                                            className: "dropdown-select",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gzHIW.default).Toggle, {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                                children: selectedYear
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                                xs: "auto",
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                                                    icon: (0, $8Qx3l.faChevronDown)
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gzHIW.default).Menu, {
                                                    children: years.map((year, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $gzHIW.default).Item, {
                                                            onClick: ()=>setSelectedYear(year),
                                                            children: year
                                                        }, index))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            id: "status",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "section-header mt-2 mb-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "header-img-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "header-img",
                                                            style: {
                                                                backgroundImage: "url('/assets/member-activities.jpeg')"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            style: {
                                                                left: "3%"
                                                            },
                                                            children: "Response status"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                className: "d-flex align-items-center",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "section-intro",
                                                    children: "How are ministers responding to written questions? Track timeous, late, and lapsed responses across the register."
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 5,
                                            className: "mb-4 mb-md-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Response status"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: "#777",
                                                            marginTop: 4
                                                        },
                                                        children: [
                                                            stats?.total.toLocaleString(),
                                                            " questions tracked"
                                                        ]
                                                    }),
                                                    stats && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "status-summary-row mt-3",
                                                                children: [
                                                                    {
                                                                        key: "timeous",
                                                                        label: "Timeous",
                                                                        count: stats.timeous,
                                                                        cls: "ss-timeous"
                                                                    },
                                                                    {
                                                                        key: "late",
                                                                        label: "Late",
                                                                        count: stats.late,
                                                                        cls: "ss-late"
                                                                    },
                                                                    {
                                                                        key: "lapsed",
                                                                        label: "Lapsed",
                                                                        count: stats.lapsed,
                                                                        cls: "ss-lapsed"
                                                                    },
                                                                    {
                                                                        key: "r146",
                                                                        label: "Rule 146",
                                                                        count: stats.r146,
                                                                        cls: "ss-r146"
                                                                    },
                                                                    {
                                                                        key: "other",
                                                                        label: "Other",
                                                                        count: stats.other,
                                                                        cls: "ss-other"
                                                                    }
                                                                ].map(({ key: key, label: label, count: count, cls: cls })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        className: `status-summary-item ${cls}`,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "ss-count",
                                                                                children: count.toLocaleString()
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                                className: "ss-pct",
                                                                                children: [
                                                                                    (count / stats.total * 100).toFixed(1),
                                                                                    "%"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                                className: "ss-label",
                                                                                children: label
                                                                            })
                                                                        ]
                                                                    }, key))
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                className: "seperator mt-3 mb-2"
                                                            }),
                                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                                                        className: "mb-1",
                                                                        children: "On-time response rate"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: 28,
                                                                            fontFamily: "'General Sans Semibold', sans-serif"
                                                                        },
                                                                        children: [
                                                                            (stats.timeous / stats.total * 100).toFixed(1),
                                                                            "%"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        className: "response-time-bar mt-1",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                            className: "rt-fill rt-timeous",
                                                                            style: {
                                                                                width: `${(stats.timeous / stats.total * 100).toFixed(1)}%`
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                                        style: {
                                                                            fontSize: 11,
                                                                            color: "#999",
                                                                            marginTop: 6
                                                                        },
                                                                        children: stats.avgDays !== null ? `Average ${stats.avgDays} days to reply \xb7 14-day rule requirement` : "Response timing data limited"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 7,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Ministers receiving the most questions"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: "#777",
                                                            marginTop: 4
                                                        },
                                                        children: "Across all question types"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "scroll-area mt-3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                            style: {
                                                                height: 260
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                                className: "sticky-header-table",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    style: {
                                                                                        width: "70%"
                                                                                    },
                                                                                    children: "Executive / Minister"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                    children: "Questions"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: (stats?.topMinisters || []).slice(0, 30).map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: i + 1
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.minister
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.count
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        style: {
                                                                                            minWidth: 80
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$CardBar, {
                                                                                            value: m.count / maxMinstCount * 100,
                                                                                            avg: 50
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, i))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            id: "register",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "section-header mt-2 mb-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "header-img-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "header-img",
                                                            style: {
                                                                backgroundImage: "url('/assets/scheduling.jpeg')"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            style: {
                                                                left: "3%"
                                                            },
                                                            children: "Questions Explorer"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                className: "d-flex align-items-center",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "section-intro",
                                                    children: [
                                                        "Browse ",
                                                        yearData.length.toLocaleString(),
                                                        " questions from Parliament's Questions Register. Where available, PMG links open the full question on pmg.org.za. Filter by type, party, minister, or status. Click column headers to sort."
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "dashboard-card mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "explorer-filters",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "d-flex align-items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                                            icon: (0, $8Qx3l.faMagnifyingGlass),
                                                            style: {
                                                                fontSize: 12,
                                                                color: "#999"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            type: "text",
                                                            placeholder: "Search member, minister, code\u2026",
                                                            value: searchText,
                                                            onChange: (e)=>{
                                                                setSearchText(e.target.value);
                                                                setPage(1);
                                                            },
                                                            style: {
                                                                minWidth: 220
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: filterType,
                                                    onChange: (e)=>{
                                                        setFilterType(e.target.value);
                                                        setPage(1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "All",
                                                            children: "All types"
                                                        }),
                                                        questionTypes.filter((t)=>t !== "All").map((t)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                value: t,
                                                                children: $2a4f034c9d8a0fd5$var$TYPE_LABELS[t] || t
                                                            }, t))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: filterParty,
                                                    onChange: (e)=>{
                                                        setFilterParty(e.target.value);
                                                        setPage(1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "All",
                                                            children: "All parties"
                                                        }),
                                                        parties.filter((p)=>p !== "All").map((p)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                children: p
                                                            }, p))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: filterMinister,
                                                    onChange: (e)=>{
                                                        setFilterMinister(e.target.value);
                                                        setPage(1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "All",
                                                            children: "All ministers"
                                                        }),
                                                        ministers.filter((m)=>m !== "All").map((m)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                children: m
                                                            }, m))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                                    value: filterStatus,
                                                    onChange: (e)=>{
                                                        setFilterStatus(e.target.value);
                                                        setPage(1);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                            value: "All",
                                                            children: "All statuses"
                                                        }),
                                                        statuses.filter((s)=>s !== "All").map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                                                children: s
                                                            }, s))
                                                    ]
                                                }),
                                                (filterParty !== "All" || filterMinister !== "All" || filterStatus !== "All" || filterType !== "All" || searchText) && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "filter-reset",
                                                    onClick: resetFilters,
                                                    children: "Reset filters"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                    className: "filter-label ms-auto",
                                                    children: [
                                                        filteredData.length.toLocaleString(),
                                                        " questions"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "scroll-area",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                style: {
                                                    height: 420
                                                },
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                    className: "sticky-header-table explorer-table",
                                                    hover: true,
                                                    style: {
                                                        tableLayout: 'fixed'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        style: {
                                                                            width: 40
                                                                        },
                                                                        children: "#"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "ACC No",
                                                                        label: "Code",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 90
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "type",
                                                                        label: "Type",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 90
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "Member asking",
                                                                        label: "Member",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 150
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "PARTY",
                                                                        label: "Party",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 90
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "Executive",
                                                                        label: "Minister / Executive",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 200
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "pubDate",
                                                                        label: "Published",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 120
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "daysToReply",
                                                                        label: "Days",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 65
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SortTh, {
                                                                        col: "displayStatus",
                                                                        label: "Status",
                                                                        sortKey: sortKey,
                                                                        sortDir: sortDir,
                                                                        onSort: handleSort,
                                                                        style: {
                                                                            width: 90
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                        style: {
                                                                            width: 70
                                                                        },
                                                                        children: "PMG"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                            children: pagedData.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                    colSpan: 10,
                                                                    className: "empty-state",
                                                                    children: "No questions match your filters"
                                                                })
                                                            }) : pagedData.map((row, i)=>{
                                                                const rowNum = (page - 1) * $2a4f034c9d8a0fd5$var$PAGE_SIZE + i + 1;
                                                                const status = (row.displayStatus || "").trim();
                                                                const pub = row["Date of publication"] || "";
                                                                const pubShort = pub ? pub.replace(/^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), /, "") : "\u2014";
                                                                const member = (row["Member asking"] || "").trim();
                                                                const exec = (row["Executive"] || row["department"] || "").trim();
                                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            style: {
                                                                                color: "#bbb"
                                                                            },
                                                                            children: rowNum
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            style: {
                                                                                fontFamily: "'General Sans Medium', sans-serif",
                                                                                color: "#333"
                                                                            },
                                                                            children: row["ACC No"] || "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "type-pill",
                                                                                children: row.typeLabel || "\u2014"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: member ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$Badge, {
                                                                                        pic: row.profile_pic
                                                                                    }),
                                                                                    member
                                                                                ]
                                                                            }) : "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: (row["PARTY"] || "").trim() ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                className: "party-pill",
                                                                                style: {
                                                                                    fontSize: 9
                                                                                },
                                                                                children: (row["PARTY"] || "").trim()
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: "#ddd"
                                                                                },
                                                                                children: "\u2014"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: exec || "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            style: {
                                                                                whiteSpace: "nowrap",
                                                                                color: "#666"
                                                                            },
                                                                            children: pubShort || "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$DaysChip, {
                                                                                days: row.daysToReply
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$StatusPill, {
                                                                                status: status
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                            children: row.pmgUrl ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                                                href: row.pmgUrl,
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                className: "pmg-link",
                                                                                children: [
                                                                                    "View ",
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEyqx.FontAwesomeIcon), {
                                                                                        icon: (0, $8Qx3l.faExternalLinkAlt),
                                                                                        style: {
                                                                                            fontSize: 9
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                style: {
                                                                                    color: "#ddd"
                                                                                },
                                                                                children: "\u2014"
                                                                            })
                                                                        })
                                                                    ]
                                                                }, i);
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)(Pagination, {
                                            current: page,
                                            total: totalPages,
                                            onChange: (p)=>setPage(p),
                                            count: filteredData.length
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                            id: "ministers",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "section-header mt-2 mb-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "header-img-container",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                            className: "header-img",
                                                            style: {
                                                                backgroundImage: "url('/assets/member-activities.jpeg')"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                                            style: {
                                                                left: "3%"
                                                            },
                                                            children: "Minister & Member activity"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                                className: "d-flex align-items-center",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "section-intro",
                                                    children: "Which ministers face the most scrutiny? Which members are most active in holding the executive to account?"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                    className: "mb-4",
                                    id: "members",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 6,
                                            className: "mb-4 mb-md-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Questions sent to ministers"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "card-big-text mt-2",
                                                        children: stats?.total.toLocaleString()
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "card-subtext",
                                                        children: "total questions"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "scroll-area mt-3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                            style: {
                                                                height: 300
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                                className: "sticky-header-table sortable-summary",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "minister",
                                                                                    label: "Minister",
                                                                                    sortKey: minSort.sortKey,
                                                                                    sortDir: minSort.sortDir,
                                                                                    onSort: minSort.onSort,
                                                                                    style: {
                                                                                        width: "55%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "count",
                                                                                    label: "Questions",
                                                                                    sortKey: minSort.sortKey,
                                                                                    sortDir: minSort.sortDir,
                                                                                    onSort: minSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: $2a4f034c9d8a0fd5$var$sortData(stats?.topMinisters || [], minSort.sortKey, minSort.sortDir).map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: i + 1
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.minister
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.count
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        style: {
                                                                                            minWidth: 80
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$CardBar, {
                                                                                            value: m.count / maxMinstCount * 100,
                                                                                            avg: 50
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, i))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 6,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Members who submitted the most questions"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "card-big-text mt-2",
                                                        children: (stats?.topMembers.reduce((s, m)=>s + m.count, 0) || 0).toLocaleString()
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "card-subtext",
                                                        children: "questions by top 30 members"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "scroll-area mt-3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                            style: {
                                                                height: 300
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                                className: "sticky-header-table sortable-summary",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "member",
                                                                                    label: "Member",
                                                                                    sortKey: memberSort.sortKey,
                                                                                    sortDir: memberSort.sortDir,
                                                                                    onSort: memberSort.onSort,
                                                                                    style: {
                                                                                        width: "55%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "party",
                                                                                    label: "Party",
                                                                                    sortKey: memberSort.sortKey,
                                                                                    sortDir: memberSort.sortDir,
                                                                                    onSort: memberSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "count",
                                                                                    label: "Questions",
                                                                                    sortKey: memberSort.sortKey,
                                                                                    sortDir: memberSort.sortDir,
                                                                                    onSort: memberSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {})
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: $2a4f034c9d8a0fd5$var$sortData(stats?.topMembers || [], memberSort.sortKey, memberSort.sortDir).map((m, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: i + 1
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$Badge, {
                                                                                                pic: m.profile_pic
                                                                                            }),
                                                                                            m.member
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.party ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            className: "party-pill",
                                                                                            style: {
                                                                                                fontSize: 9
                                                                                            },
                                                                                            children: m.party
                                                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                            style: {
                                                                                                color: "#ddd"
                                                                                            },
                                                                                            children: "\u2014"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        children: m.count
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                        style: {
                                                                                            minWidth: 80
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$CardBar, {
                                                                                            value: m.count / maxMemberCount * 100,
                                                                                            avg: 50
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, i))
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h7C4J.default), {
                                    className: "mb-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                        md: 12,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "dashboard-card",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                    children: "Questions asked by party"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: "#777",
                                                        marginTop: 4
                                                    },
                                                    children: "How many questions each party submitted"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "scroll-area mt-3",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                        style: {
                                                            height: 220
                                                        },
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                            className: "sticky-header-table sortable-summary",
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                col: "party",
                                                                                label: "Party",
                                                                                sortKey: partySort.sortKey,
                                                                                sortDir: partySort.sortDir,
                                                                                onSort: partySort.onSort,
                                                                                style: {
                                                                                    width: "40%"
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                col: "count",
                                                                                label: "Questions",
                                                                                sortKey: partySort.sortKey,
                                                                                sortDir: partySort.sortDir,
                                                                                onSort: partySort.onSort
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                col: "pct",
                                                                                label: "% of total",
                                                                                sortKey: partySort.sortKey,
                                                                                sortDir: partySort.sortDir,
                                                                                onSort: partySort.onSort
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                                                style: {
                                                                                    minWidth: 120
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                    children: $2a4f034c9d8a0fd5$var$sortData((stats?.topParties || []).map((p)=>({
                                                                            ...p,
                                                                            pct: p.count / (stats?.total || 1) * 100
                                                                        })), partySort.sortKey, partySort.sortDir).map((p, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    children: i + 1
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                                                        className: "party-pill",
                                                                                        children: p.party
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    children: p.count
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                    children: [
                                                                                        p.pct.toFixed(1),
                                                                                        "%"
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$CardBar, {
                                                                                        value: p.count / (stats?.topParties[0]?.count || 1) * 100,
                                                                                        avg: 100 / (stats?.topParties.length || 1)
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }, i))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $h7C4J.default), {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 6,
                                            className: "mb-4 mb-md-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Ministers with most late responses"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: "#777",
                                                            marginTop: 4
                                                        },
                                                        children: "Based on response status data"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "scroll-area mt-3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                            style: {
                                                                height: 260
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                                className: "sticky-header-table sortable-summary",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "minister",
                                                                                    label: "Executive",
                                                                                    sortKey: lateSort.sortKey,
                                                                                    sortDir: lateSort.sortDir,
                                                                                    onSort: lateSort.onSort,
                                                                                    style: {
                                                                                        width: "50%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "late",
                                                                                    label: "Late",
                                                                                    sortKey: lateSort.sortKey,
                                                                                    sortDir: lateSort.sortDir,
                                                                                    onSort: lateSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "total",
                                                                                    label: "Total",
                                                                                    sortKey: lateSort.sortKey,
                                                                                    sortDir: lateSort.sortDir,
                                                                                    onSort: lateSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "pct",
                                                                                    label: "%",
                                                                                    sortKey: lateSort.sortKey,
                                                                                    sortDir: lateSort.sortDir,
                                                                                    onSort: lateSort.onSort
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: (()=>{
                                                                            const byMin = {};
                                                                            yearData.forEach((row)=>{
                                                                                const exec = (row["Executive"] || row["department"] || "").trim();
                                                                                if (!exec) return;
                                                                                if (!byMin[exec]) byMin[exec] = {
                                                                                    total: 0,
                                                                                    late: 0
                                                                                };
                                                                                byMin[exec].total++;
                                                                                const s = (row.displayStatus || "").toUpperCase().trim();
                                                                                if (s === "LATE") byMin[exec].late++;
                                                                            });
                                                                            return $2a4f034c9d8a0fd5$var$sortData(Object.entries(byMin).map(([m, d])=>({
                                                                                    minister: m,
                                                                                    ...d,
                                                                                    pct: d.total > 0 ? d.late / d.total * 100 : 0
                                                                                })).filter((d)=>d.late > 0), lateSort.sortKey, lateSort.sortDir).slice(0, 20).map((d, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: i + 1
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: d.minister
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            style: {
                                                                                                color: "#dc2626",
                                                                                                fontFamily: "'General Sans Semibold', sans-serif"
                                                                                            },
                                                                                            children: d.late
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: d.total
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("td", {
                                                                                            children: [
                                                                                                d.pct.toFixed(0),
                                                                                                "%"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }, i));
                                                                        })()
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99eL8.default), {
                                            md: 6,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "dashboard-card h-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                                        children: "Ministers with the fastest response times"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                        style: {
                                                            fontSize: 12,
                                                            color: "#777",
                                                            marginTop: 4
                                                        },
                                                        children: "Average days to reply (answered questions only)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "scroll-area mt-3",
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7lKbG.Scrollbars), {
                                                            style: {
                                                                height: 260
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $j3TSU.default), {
                                                                className: "sticky-header-table sortable-summary",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {}),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "minister",
                                                                                    label: "Executive",
                                                                                    sortKey: fastSort.sortKey,
                                                                                    sortDir: fastSort.sortDir,
                                                                                    onSort: fastSort.onSort,
                                                                                    style: {
                                                                                        width: "50%"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "avg",
                                                                                    label: "Avg days",
                                                                                    sortKey: fastSort.sortKey,
                                                                                    sortDir: fastSort.sortDir,
                                                                                    onSort: fastSort.onSort
                                                                                }),
                                                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$SimpleSortTh, {
                                                                                    col: "count",
                                                                                    label: "Questions",
                                                                                    sortKey: fastSort.sortKey,
                                                                                    sortDir: fastSort.sortDir,
                                                                                    onSort: fastSort.onSort
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                                                        children: (()=>{
                                                                            const byMin = {};
                                                                            yearData.forEach((row)=>{
                                                                                const exec = (row["Executive"] || row["department"] || "").trim();
                                                                                if (!exec || row.daysToReply === null || isNaN(row.daysToReply) || row.daysToReply < 0) return;
                                                                                if (!byMin[exec]) byMin[exec] = {
                                                                                    total: 0,
                                                                                    sumDays: 0
                                                                                };
                                                                                byMin[exec].total++;
                                                                                byMin[exec].sumDays += row.daysToReply;
                                                                            });
                                                                            return $2a4f034c9d8a0fd5$var$sortData(Object.entries(byMin).map(([m, d])=>({
                                                                                    minister: m,
                                                                                    count: d.total,
                                                                                    avg: d.total > 0 ? Math.round(d.sumDays / d.total) : 999
                                                                                })).filter((d)=>d.count >= 3), fastSort.sortKey, fastSort.sortDir).slice(0, 20).map((d, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: i + 1
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: d.minister
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2a4f034c9d8a0fd5$var$DaysChip, {
                                                                                                days: d.avg
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                                                            children: d.count
                                                                                        })
                                                                                    ]
                                                                                }, i));
                                                                        })()
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
var $2a4f034c9d8a0fd5$export$2e2bcd8739ae039 = $2a4f034c9d8a0fd5$var$QuestionsExplorer;



function $11e5d23485be17b3$var$App() {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2a4f034c9d8a0fd5$export$2e2bcd8739ae039), {});
}
const $11e5d23485be17b3$var$container = document.getElementById('root');
const $11e5d23485be17b3$var$root = (0, $aRPiL.createRoot)($11e5d23485be17b3$var$container);
$11e5d23485be17b3$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($11e5d23485be17b3$var$App, {}));


//# sourceMappingURL=questions.f858ebe6.js.map
